import reducer from './locale-reducer';

export default reducer;
export { initialState } from './locale-reducer';

export * from './locale-actions';
